<template>
    <div v-bind="$attrs">
        <highcharts :options="chartOptions" ref="chartDonut"></highcharts>

        <slot name="content"></slot>
        <div class="highcharts-data-table">
            <table v-if="showTable" class="custom-table">
                <caption class="highcharts-table-caption"></caption>
                <thead>
                    <tr>
                    <!--<th class="highcharts-empty"></th>-->
                    <th class="highcharts-text">
                        {{chartOptions.title.text}}
                    </th>
                    <th class="highcharts-text" v-html="checkIfPrice(chartOptions.subtitle.text)?'VALOR':'QTD'">
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(point, i) in chartOptions.series[0].data" :key="i">
                        <td class="highcharts-text"> {{ i+1 }} - {{ point.name }}</td>
                        <td class="highcharts-number" v-if="checkIfPrice(chartOptions.subtitle.text)">
                            {{ formatIntegerPrice(point.y,2,2) }}
                        </td>
                        <td class="highcharts-number" v-else v-html="formateQty(point.y, 0)">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { colors } from "@/Composables/ChartColors";
import * as Highcharts from 'highcharts';
import { formatIntegerPrice } from "@/Mixins/Formatting";
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';

import 'highcharts/modules/exporting'
import "highcharts/modules/accessibility";
import "highcharts/modules/export-data";
import "highcharts/modules/no-data-to-display";

//import "highcharts/modules/accessibility";

/*Highcharts.setOptions({
            lang: {
            locale: "pt",
            noData: i18n.t('charts.noData'),
            exportData: {
                categoryHeader: "",
            },
        },
})*/
export default {
    props: {
        options: {
            type: Object,
            default: function () {
                return {};
            },
        },

        height: {
            type: String,
            default: "100%",
        },

        width: {
            type: String,
            default: "100%",
        },

        series: {
            type: Array,
            default:[],
            required: true,
        },

        labels: {
            type: Array,
            //required: true,
        },
        title:{
            type:String,
            default:null
        },
        subtitle:{
            type:String,
            default:''
        },

        keyTarget:{
            type:String,
            default:null
        },

        isPriceChart: {
            type: Boolean,
            default: false,
        },

        showTotal:{
            type: Boolean,
            default: true,
        }
    },
    data() {
       return{
          showTable:false
       }
    },
    computed: {
        ...mapStores(useUserStore),
        hidePrices() {
            return this.userStore.hasPermissionTo('Consumptions - Hide Prices');
        },
        chartOptions() {
            return {
                exporting:{
                    enabled: true,
                    //url: 'https://code.highcharts.com/12.2.0/lib/',
                    //libURL: 'https://code.highcharts.com/12.2.0/lib/', // Use versão compatível
                    fallbackToExportServer: false, // impede uso do export server
                    sourceWidth: 1920,
                    sourceHeight: 1080,
                    buttons: {
                        contextButton: {
                        menuItems: !this.hidePrices?[
                               'viewFullscreen',
                                'printChart',
                                'separator',
                                'downloadPNG',
                                'downloadJPEG',
                                'downloadSVG',
                                'separator',
                                'downloadCSV',
                                //'downloadXLS',
                                {
                                    text: this.showTable ? i18n.t('charts.hideData') : i18n.t('charts.viewData'),
                                    onclick: () => {
                                        this.showTable = !this.showTable
                                    }
                                },
                             /*'viewFullscreen',
                             {
                           text: this.showTable ? i18n.t('charts.hideData') : i18n.t('charts.showData'),
                                onclick: () => {
                                    // Custom event que vamos capturar no Vue
                                    const event = new CustomEvent('toggleCustomTable')
                                    window.dispatchEvent(event)
                                }
                            },
                            'downloadPNG',
                            'downloadPDF'*/
                        ]:['viewFullscreen',
                                'printChart',
                                'separator',
                                'downloadPNG',
                                'downloadJPEG',
                                'downloadSVG']
                        }
                    }
                },
                lang: {
                        locale: "pt",
                        noData: i18n.t('charts.noData'),
                        exportData: {
                            categoryHeader: "",
                        },
                        contextButtonTitle: i18n.t('charts.menu'),
                        downloadJPEG: i18n.t('charts.downloadJPEG'),
                        downloadPDF: i18n.t('charts.downloadPDF'),
                        downloadPNG: i18n.t('charts.downloadPNG'),
                        downloadSVG: i18n.t('charts.downloadSVG'),
                        downloadCSV: i18n.t('charts.downloadCSV'),
                        downloadXLS: i18n.t('charts.downloadXLS'),
                        viewFullscreen: i18n.t('charts.fullscreen'),
                        printChart: i18n.t('charts.print'),
                        exitFullscreen: i18n.t('charts.exitFullscreen'),
                        viewData: i18n.t('charts.viewData'),
                        loading: i18n.t('charts.loading'),
                        //noData: 'Sem dados para mostrar'
                },
                credits: {
                    enabled: false,
                },
                // //"#006db6", "#26aaff"'#154579'
                colors:['#006db6','#0d8ccd','#9ccfff','#cbe3fa','#e9770f','#ed8d36','#ecaa6e','#f6c79b','#fde9d4','#fde9c3'],
                chart: {
                    //maxWidth:400,
                    type: "pie",
                    custom: {},
                    events: this.showTotal && _.size(this.series)>0? {
                        render() {
                            const chart = this,
                                series = chart.series[0];
                                let customLabel = chart.options.chart.custom.label;
                             let total=0
                             _.each(series.data,(o)=>{
                                total+=o.options.y
                             })

                            if (!customLabel) {
                                //let total= this.isPriceChart?this.total+'€':this.total
                                if(this.subtitle.textStr.search(/preço|price/i) !== -1){
                                    total = total.toLocaleString('de-DE', {
                                            style: 'currency',
                                            currency: 'EUR',
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    //total = Highcharts.numberFormat( total, 2) + "€"
                                }else{
                                    total = Highcharts.numberFormat( total, 0)
                                }


                                /*if(Number(total) === total && total % 1 !== 0){
                                    //total=_.floor( total,2)
                                    //total = total+' €'
                                    total = Highcharts.numberFormat( total, 2) + "€"
                                }else{
                                    total = Highcharts.numberFormat( total, 0)
                                }*/
                                customLabel = chart.options.chart.custom.label =
                                    chart.renderer
                                        .label(
                                            "<div class='wrap-total'>"+i18n.t('charts.total')+"<br/>" +
                                                "<strong>"+total+"</strong></div>"
                                        )
                                        .css({
                                            color: "#000",
                                            fontSize: "0.8em!important",
                                            textAnchor: "middle",
                                        })
                                        .add();
                            }

                            const x = series.center[0] + chart.plotLeft,
                                y =
                                    series.center[1] +
                                    chart.plotTop -
                                    customLabel.attr("height") / 2;

                            customLabel.attr({
                                x,
                                y,
                            });
                            // Set font size based on chart diameter
                            customLabel.css({
                                fontSize: `${series.center[2] / 12}px`,
                            });
                        },
                    }:{},
                },
                accessibility: {
                    point: {
                        valueSuffix: "%",
                    },
                    /*enabled:true,
                    table:{
                        rowFormatter: function(row,series,point){
                            console.log('rowFormatter',point)
                            if(point){
                                let value=null
                                if(this.point.y>1000){
                                    value = (this.point.y/1000).toFixed(1) + "€"
                                }else{
                                    value = this.point.y+ '€'
                                }
                                return { ...row,
                                    children :[
                                        {
                                            scope:'row',
                                            text:point.category
                                        },
                                        {
                                            text: value
                                        }
                                    ]
                                };
                            }
                            return row
                        }
                    }*/
                },
                title: {
                    text: _.toUpper(this.title),
                    align: 'left',
                    style: {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        //fontFamily: 'Spartan',
                        color: '#006DB6',
                        //color: '#154579',
                    },
                },
                subtitle: {
                    text: this.subtitle,
                    align: 'left',
                },
                tooltip: {
                    pointFormat:this.isPriceChart?"<b>{point.percentage:.1f}%</b> | <b>{point.y:,.%0f} €</b>":"<b>{point.percentage:.1f}%</b> | <b>{point.y:,f} </b>",
                },
                legend: {
                    //onArea:false,
                    enabled: window.innerWidth>=1024? true:false,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemWidth:400,
                    //floating:true,
                    /*style:{
                        minWidth:'100',
                        maxWidth:'100',
                    },*/
                    //minWidth:'100',
                    //maxWidth:'100',
                    //useHTML:true,
                    //connectorNeighbourDistance:50
                    //itemMarginTop: 20,
                    //itemMarginBottom: 20
                },
                plotOptions: {
                    series: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        borderRadius: 5,
                        center:window.innerWidth>1366?['300','50%']:window.innerWidth<=600?['50%','50%']:['200','50%'],
                        dataLabels: [
                            {
                                enabled: false,
                                useHTML: false,
                                distance: 20,
                                format: "{point.name}",
                                style: {
                                    fontSize: "0.7em",
                                    fontWeight:'normal',
                                    textOutline:'none',
                                },
                            },
                            {
                                enabled: true,
                                useHTML: false,
                                distance: -30,
                                format: "{point.percentage:.1f}%",
                                style: {
                                    fontSize: "0.7em",
                                    fontWeight:'normal',
                                    textOutline:'none',
                                },
                            },
                        ],
                        showInLegend: true,
                    },
                },
                series: [
                    {
                        name: i18n.t('charts.value'),
                        colorByPoint: true,
                        innerSize: this.showTotal?"60%":"30%",
                        data: this.getSeries()
                    },
                ],
            };
        },
    },
    /*data() {
        return {
            colors:["#006db6", "#26aaff", "#f7b305"],
            total:0
        };
    },*/
    destroyed(){
        //window.EventBus.$off('update:chartDonut');
    },
    mounted() {
        /* window.EventBus.$on('update:chartDonut', (e) => {
            //console.log('product-search',e)
            this.updateChart(e)
        })*/
        window.addEventListener('toggleCustomTable', this.toggleTable)
    },
    beforeDestroy() {
        window.removeEventListener('toggleCustomTable', this.toggleTable)
    },
    methods: {
        formateQty(val){
            return Highcharts.numberFormat(val, 0)
        },
        checkIfPrice(str){
            return str.search(/preço|price/i) !== -1
        },
        toggleTable() {
            this.showTable = !this.showTable
        },
        formatValue(value) {
            return value >= 1000 ? (value / 1000).toFixed(1) + '€' : value + '€'
        },
        updateChart(val) {
        //this.chartOptions.series[seriesIndex].data = newData;
            setTimeout(()=>{
                this.$refs.chartDonut.chart.redraw();
            },3000)

        },
        getSeries(){
            let result=[];
            _.each(this.series,(o,i)=>{
                this.total+=o[this.keyTarget]
                let obj={
                    name:o.name,
                    y:o[this.keyTarget]
                }
                result.push(obj)
            })
            return result
        }
  }
};
</script>

<style>


#app .wrap-total{
  font-size: 0.9rem!important;
}
</style>
